import NextLink from "next/link";
import { useExtendedRouter } from "hooks";
import { useTranslations } from "contexts/LocalizationContext";
import { trackUAClickEvent } from "utils/tracking/utils";
import { Link } from "@chakra-ui/react";
import type { MenuLinkProps } from "./MenuLink.d";

const MenuLink = ({ menuItem, linkType, ...props }: MenuLinkProps) => {
  const translations = useTranslations();
  const { label, href, attributes = {}, icon, dataQA, subMenu } = menuItem;
  const { target, rel } = attributes;
  const { asPath: pagePath } = useExtendedRouter();
  const linkFontWeight = pagePath === `${href}/` ? "medium" : "normal";
  const relAttribute = !rel ? (target === "_blank" ? "noopener noreferrer" : undefined) : rel;

  const Icon = icon;

  const handleOnClick = () => {
    if (menuItem.trackingEvent?.length === 2) {
      trackUAClickEvent(menuItem.trackingEvent[0], menuItem.trackingEvent[1]);
    }
  };

  return (
    <Link
      as={href && !subMenu ? NextLink : linkType}
      _first={{ mt: 1 }}
      borderRadius="sm"
      fontWeight={linkFontWeight}
      sx={{ svg: { boxSize: 3 } }}
      role="menuitem"
      key={label}
      href={href}
      target={target}
      rel={relAttribute}
      data-testid={dataQA}
      onClick={handleOnClick}
      _visited={{}}
      {...props}
    >
      {translations(label)}
      {icon && <Icon boxSize={3} ml={2} display={{ base: "none", lg: "inline" }} />}
    </Link>
  );
};

export default MenuLink;
